import React from 'react';

import { DispensaryContext } from './DispensaryProvider';
import { ProductCategoryContext } from '../productCategory/ProductCategoryProvider';
import FilteredProductsProvider from '../products/FilteredProductsProvider';
import Dispensary from './Dispensary';

import PropTypes from 'prop-types';

const DispensaryWithNewContext = ({
  dispensaryId,
  productCategoryName
}) => {

  const { dispensary, setDispensaryId } = React.useContext(DispensaryContext);
  const { defaultCategory, getCategoryFromDisplayName } = React.useContext(ProductCategoryContext); 
  
  // Category Object ( default or derived from URL )
  const [currentCategory, setCurrentCategory] = React.useState();
  // Scroll to products if category is in URL
  const [scrollToProducts, setScrollToProducts] = React.useState(false);

  // Set/Update DispensaryProvider
  React.useEffect(() => {
    if (dispensaryId && dispensaryId !== dispensary?.id) {
       setDispensaryId(dispensaryId);
    }
  }, [dispensary, dispensaryId, setDispensaryId]);
  
  // Determine product category ( from URL or default ) 
  React.useEffect(() => {
    if (!currentCategory) {
      if (productCategoryName) {
        setCurrentCategory(getCategoryFromDisplayName(productCategoryName));
        setScrollToProducts(true);
      } else if (defaultCategory) {
        setCurrentCategory(defaultCategory);
      }
    }   
  }, [productCategoryName, defaultCategory, currentCategory, getCategoryFromDisplayName]);  

  return (
    dispensaryId && currentCategory
    ? <FilteredProductsProvider dispensaryId={dispensaryId} initialCategory={currentCategory.display_name}>
        <Dispensary 
          dispensaryId={dispensaryId} 
          productCategory={currentCategory} 
          scrollToProducts={scrollToProducts} />
      </FilteredProductsProvider>  
    : null 
  );
} 

DispensaryWithNewContext.propTypes = {
  /* all via reach router, undefined initially */
  dispensaryId: PropTypes.string,
  productCategoryName: PropTypes.string
};
export default DispensaryWithNewContext;